import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: currentColor;\n\tdisplay: inline-flex;\n\theight: 54px;\n\tleft: 50%;\n\tpadding: 10px;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 54px;\n\n\t> div {\n\t\tanimation: ComponentsUISpinnerFadeAnimation 1000ms linear infinite;\n\t\tbackground: currentColor;\n\t\tborder-radius: 50px;\n\t\theight: 16%;\n\t\tleft: 49%;\n\t\topacity: 0;\n\t\tposition: absolute;\n\t\ttop: 43%;\n\t\twidth: 6%;\n\t}\n\n\t@keyframes ComponentsUISpinnerFadeAnimation {\n\t\tfrom {\n\t\t\topacity: 1;\n\t\t}\n\t\tto {\n\t\t\topacity: 0.25;\n\t\t}\n\t}\n\n\t.InnerBar1 {\n\t\tanimation-delay: 0s;\n\t\ttransform: rotate(0deg) translate(0, -130%);\n\t}\n\n\t.InnerBar2 {\n\t\tanimation-delay: -0.9167s;\n\t\ttransform: rotate(30deg) translate(0, -130%);\n\t}\n\n\t.InnerBar3 {\n\t\tanimation-delay: -0.833s;\n\t\ttransform: rotate(60deg) translate(0, -130%);\n\t}\n\t.InnerBar4 {\n\t\tanimation-delay: -0.7497s;\n\t\ttransform: rotate(90deg) translate(0, -130%);\n\t}\n\t.InnerBar5 {\n\t\tanimation-delay: -0.667s;\n\t\ttransform: rotate(120deg) translate(0, -130%);\n\t}\n\t.InnerBar6 {\n\t\tanimation-delay: -0.5837s;\n\t\ttransform: rotate(150deg) translate(0, -130%);\n\t}\n\t.InnerBar7 {\n\t\tanimation-delay: -0.5s;\n\t\ttransform: rotate(180deg) translate(0, -130%);\n\t}\n\t.InnerBar8 {\n\t\tanimation-delay: -0.4167s;\n\t\ttransform: rotate(210deg) translate(0, -130%);\n\t}\n\t.InnerBar9 {\n\t\tanimation-delay: -0.333s;\n\t\ttransform: rotate(240deg) translate(0, -130%);\n\t}\n\t.InnerBar10 {\n\t\tanimation-delay: -0.2497s;\n\t\ttransform: rotate(270deg) translate(0, -130%);\n\t}\n\t.InnerBar11 {\n\t\tanimation-delay: -0.167s;\n\t\ttransform: rotate(300deg) translate(0, -130%);\n\t}\n\t.InnerBar12 {\n\t\tanimation-delay: -0.0833s;\n\t\ttransform: rotate(330deg) translate(0, -130%);\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\theight: ", ";\n\tleft: 0;\n\topacity: 0.6;\n\tposition: absolute;\n\ttop: 0;\n\ttransform-origin: top left;\n\twidth: ", ";\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tpointer-events: none;\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { styled, ui } from '@wp-g2/styles';
import { WRAPPER_SIZE } from './Spinner.utils';
export var ContainerView = styled.div(_templateObject());
export var BarsWrapperView = styled.div(_templateObject2(), ui.value.px(WRAPPER_SIZE), ui.value.px(WRAPPER_SIZE));
export var BarsView = styled.div(_templateObject3());